<script setup>
import StarLine from '@/components/stars/StarLine.vue'
import BlockAroundConfirm from '../content/BlockAroundConfirm.vue'

import { getDateString } from "@/stores/formatDate";

const commentsStringIsHelpThisMessage = window.commentsIsHelpThisMessage

const comments = window.commentsAll

const isAutoDateOfCommentsEnabled = !!window.isAutoDateOfCommentsEnabled
const formatDateOfComments = window.formatDateOfComments || 'DD.MM.YYYY'

function getDateString_local(dateCustom, index) {
   if (isAutoDateOfCommentsEnabled) {
      return getDateString({
         index: index || 0,
         format: formatDateOfComments
      })
   } else
      return dateCustom
}

</script>

<template>
   <div class="grid-container">

      <div class="commentContainer" v-for="(item, index) in comments" :key="index">

         <div class="title-container">

            <div>
               <img class="title-container__logo" :src="item.img_url" alt="">
            </div>

            <div class="title">
               {{ item.userName }}
            </div>

            <div class="button-container">
               <i class="google-material-icons button-container__button-to" aria-hidden="true">more_vert</i>
            </div>

         </div>

         <div class="star_time_container block_top_add">
            <div class="addition_star_padding">
               <StarLine :size="12" :score="item.score || 0" />
            </div>
            <span class="message_container__liked">{{ getDateString_local(item.date, index) }}</span>
            <!-- <span class="message_container__liked">{{ item.date }}</span> -->

         </div>

         <div class="message_container">
            {{ item.message }}
         </div>

         <div class="message_container message_container__liked block_top_add w100">
            <span class="message_container_RTL">
               {{ item.peopleLikedBlock }}
            </span>
         </div>

         <div class="message_container message_container__liked block_top_add">
            <span class="message_container_RTL">
               {{ commentsStringIsHelpThisMessage }}
            </span>
            <BlockAroundConfirm />
         </div>

         <div class="answer_container" v-if="!!item.developer">
            <div class="answer_container__heead">
               <div class="answer_container__title">{{ item.developer.userName }}</div>

               <div class="answer_container__description">{{ getDateString_local(item.developer.date, index) }}</div>
               <!-- <div class="answer_container__description">{{ item.developer.date }}</div> -->
            </div>
            <div class="answer_container__body">
               <div>{{ item.developer.message }}</div>
            </div>
         </div>

      </div>

   </div>

</template>

<style lang="scss" scoped>
.addition_star_padding {
   padding: 10px 0;
}

.message_container {
   font-family: Roboto, Helvetica, Arial, sans-serif;
   font-size: .875rem;
   font-weight: 400;
   letter-spacing: .0142857143em;
   line-height: 1.25rem;
   display: -webkit-box;
   -webkit-box-orient: vertical;
   -webkit-line-clamp: 6;
   line-clamp: 6;
   max-height: 7.5rem;
   overflow: hidden;
   text-overflow: ellipsis;
   color: var(--data_color_additional_text);
}

.block_top_add {
   margin-top: 16px;
}

.message_container__liked {
   display: flex;
   align-items: center;

   font-family: Roboto, Arial, sans-serif;
   font-size: 0.75rem;
   font-weight: 400;
   letter-spacing: 0.025em;
   line-height: 1rem;
   margin-left: 10px;
}

.star_time_container {
   display: flex;
   align-items: center;
   flex-wrap: nowrap;
}

.title-container_ {
   &_logo {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      overflow: hidden;
      background-size: cover;
   }
}

.text_ {
   &_about_app {
      font-family: Roboto, Helvetica, Arial, sans-serif;
      font-size: .875rem;
      font-weight: 400;
      letter-spacing: .0142857143em;
      line-height: 1.25rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 6;
      line-clamp: 6;
      max-height: 7.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      color: var(--data_color_additional_text);
   }
}

.button-container__button-to {
   color: var(--data__common_behind_color);
   // color: rgb(95, 99, 104);
   fill: var(--data__common_behind_color);
   // fill: rgb(95, 99, 104);
   stop-color: var(--data__common_behind_color);
   // stop-color: rgb(95, 99, 104);
   font-size: 20px;
   padding: 2px;
   user-select: none;
   cursor: pointer;
   margin-left: -10px;
}

.button-container__button-to:hover::before {
   content: '';
   position: absolute;
   background-color: rgb(0, 0, 0);
   opacity: .04;
   padding: 25px;
   border-radius: 50px;
   transform: translate(-30%, -30%);
}

.grid-container {
   display: grid;
   grid-template-rows: auto 1fr;
   gap: 10px;
   width: 100%;
}

.title-container {
   display: grid;
   grid-template-columns: 40px 1fr 40px;
   align-items: center;
   width: 100%;
   margin-top: 20px;
}

.title {
   padding: 0 10px;
   font-family: "Google Sans", Roboto, Arial, sans-serif;
   line-height: 1.5rem;
   font-size: 1.125rem;
   letter-spacing: 0;
   font-weight: 400;
   font-weight: 500;
   display: flex;
   justify-content: space-between;
}

.button-container {}

.content {
   padding: 10px;
}

// answer_container
.answer_container {
   display: grid;
   align-items: center;
   margin: 24px 24px 0;
   padding: 12px 16px 16px;
   grid-row-gap: 12px;
   grid-template-columns: 1fr;
   background-color: var(--data_answer_container_background);
   // background-color: rgb(248, 249, 250);
}

.answer_container__heead {
   display: flex;
   align-items: center;
   gap: 4px;
}

.answer_container__body {
   // fill: rgb(95, 99, 104);
   // stop-color: rgb(95, 99, 104);
   font-size: .875rem;
   font-weight: 400;
   letter-spacing: .0142857143em;
   line-height: 1.25rem;
}

.answer_container__body {
   // color: rgb(95, 99, 104);
   // fill: rgb(95, 99, 104);
   color: var(--data_color_additional_text);
   // stop-color: rgb(95, 99, 104);
   font-size: .875rem;
   font-weight: 400;
   letter-spacing: .0142857143em;
   line-height: 1.25rem;
}

.answer_container__title {
   // fill: rgb(32, 33, 36);
   // stop-color: rgb(32, 33, 36);
   color: var(--data_color_additional_text);
   font-size: .875rem;
   font-weight: 500;
   letter-spacing: .0142857143em;
   line-height: 1.25rem;
}

.answer_container__description {
   color: var(--data_color_additional_text);
   // color: rgb(95, 99, 104);
   // fill: rgb(95, 99, 104);
   // stop-color: rgb(95, 99, 104);
   font-family: Roboto, Arial, sans-serif;
   line-height: 1rem;
   font-size: .75rem;
   letter-spacing: .025em;
   font-weight: 400;
   margin-left: auto;
}
</style>
